import { useEffect, useId, useState } from "react";
import "./PlateInput.css";

const RX_MERCOSUL = /^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/;
const RX_ANTIGA   = /^[A-Z]{3}[0-9]{4}$/;
const isValidPlate = (p="") => RX_MERCOSUL.test(p.toUpperCase()) || RX_ANTIGA.test(p.toUpperCase());

export default function PlateInput({
  value,
  onChange,
  onSubmit,
  disabled = false,
  autoFocus = false,
  help = "Digite a placa no formato Mercosul (ABC1D23) ou antigo (ABC1234).",
}) {
  const [err, setErr] = useState("");
  const id = useId();

  const sanitize = (raw) => raw.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 7);

  function handleChange(e) {
    const v = sanitize(e.target.value);
    onChange?.(v);
    if (v.length < 7) setErr("");
  }
  function handleKeyDown(e) {
    if (e.key === "Enter") trySubmit();
  }
  function trySubmit() {
    if (!value || value.length !== 7) return setErr("A placa deve ter 7 caracteres (A–Z/0–9).");
    if (!isValidPlate(value)) return setErr("Placa inválida. Use ABC1D23 (Mercosul) ou ABC1234 (antigo).");
    setErr(""); onSubmit?.(value);
  }

  useEffect(() => { if (value?.length === 7) setErr(isValidPlate(value) ? "" : "Placa inválida."); }, [value]);

  return (
    <div className="plate-container">
      <label className="plate-label" htmlFor={id}>Placa</label>

      <div className={`plate ${err ? "plate-error" : ""}`}>
        <div className="plate-top">
          <span className="country">BRASIL</span>
          <span className="flag" aria-hidden>🇧🇷</span>
        </div>
        <div className="plate-body">
          <input
            id={id}
            className="plate-input"
            type="text"
            inputMode="latin"
            pattern="[A-Za-z0-9]{7}"
            autoCapitalize="characters"
            autoComplete="off"
            spellCheck="false"
            maxLength={7}
            value={value}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            placeholder="ABC1D23"
            disabled={disabled}
            autoFocus={autoFocus}
          />
        </div>
      </div>

      <button type="button" className="btn primary plate-submit" onClick={trySubmit} disabled={disabled}>
        Consultar
      </button>

      <div className="hint center">{help}</div>
      {err && <div className="err">{err}</div>}
    </div>
  );
}

export { isValidPlate };
